/* eslint-disable no-underscore-dangle */

const _require = require('lodash'),
  isPlainObject = _require.isPlainObject;
const _require2 = require('../lib/evaluateSource'),
  evaluateSource = _require2.evaluateSource;
const _require3 = require('../lib/common'),
  flattenCollection = _require3.flattenCollection;

/**
  * @function evalute - evaluate flattenCollectionBehavior
  */

const evaluate = async (source, content, parentContentPath, transientContext, nativeFunctions) => {
  const collection = await evaluateSource(source.collection, content, parentContentPath, transientContext, nativeFunctions);
  if (collection === undefined || !isPlainObject(collection)) {
    return undefined;
  }
  return flattenCollection(collection);
};
module.exports = {
  evaluate
};